import React from 'react';
import { LoadingSpinner } from '../../icons/LoadingSpinner';
export const Loading = ({ text, style, absolute = true, onlyText = false, }) => {
    if (onlyText) {
        return React.createElement("div", { style: { fontSize: style ? style.fontSize : '2vw' } }, text);
    }
    return (React.createElement("div", { className: absolute ? 'spinner' : '', style: { display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', ...style } },
        React.createElement("div", { style: { fontSize: style ? style.fontSize : '2vw' } }, text),
        React.createElement("div", null,
            React.createElement(LoadingSpinner, null))));
};
export default Loading;
